import {
  defaultUsuario,
  defaultEmpresa,
  defaultImagen,
  defaultUserFilter,
  listadoUsuario,
  defaultDiseno,
  defaultMensaje,
  defaultCamposPersonalizados,
  defaultParamsContratista,
  defaultCompanyFilter,
  dataInititalFdsConfigsReport
} from './state';

/**
 * Mutación para limpiar formulario de imágenes de empresas
 *
 * @export
 * @param {*} state
 */
export function resetImagen(state) {
  Object.assign(state.selectedImagen, defaultImagen());
  Object.assign(state.selectedImagenCurrentCompany, defaultImagen());
}

export function setListarEmpresas(state, empresas) {
  state.empresas = empresas;
}

export function cargarEmpresas(state, optempresa) {
  state.optempresa = [];

  for (var i = 0; i < optempresa.length; i++) {
    state.optempresa.push({ value: optempresa[i].id, text: optempresa[i].nombre });
  }
}

export function setDatosEmpresa(state, dato) {
  state.selectedEmpresa = dato;
}

export function setListaRol(state, dato) {
  state.selectedEmpresa = dato;
}

export function setListadoHistorico(state, dato) {
  if (dato.data !== []) {
    state.listadoHistorico = dato.data;
  }
}

export function setListadoUsuario(state, dato) {
  state.listadoUsuario = dato.data;
}

/**
 * Mutación para limpiar los usuarios de la tabla.
 *
 * @export
 * @param {*} state
 */
export function resetListadoUsuario(state) {
  Object.assign(state.listadoUsuario, listadoUsuario())
}

export function setIdEmpresaSelectedUsuario(state, id) {
  state.selectedUsuario.id_empresa = id;
}

export function setEditaUsuario(state, dato) {
  state.edicionUsuario = dato.data;
}

export function usuarioEditaError(state) {
}

export function setDiseno(state, dato) {
  if (dato.fondo !== null) {
    dato.selectedFormatoEtiqueta = null;
    state.selectedDiseno = dato;
  }

  let formatosEtiqueta = [];
  for (let i = 0; i < dato.formatos_etiquetas_seleccionados.length; i++) {
    if(dato.formatos_etiquetas_seleccionados[i] === 'pdf'){
      formatosEtiqueta.push({'value': 'pdf', 'text': 'Pdf'})
    }
    if(dato.formatos_etiquetas_seleccionados[i] === 'word'){
      formatosEtiqueta.push({'value': 'word', 'text': 'Word'})
    }
  }

  let index = formatosEtiqueta.findIndex(i => i.value === state.selectedDiseno.selectedFormatoEtiqueta);

  if (index === -1) {
    state.selectedDiseno.selectedFormatoEtiqueta = formatosEtiqueta[0].value;
  }

  state.formatosEtiquetaEmpresa = formatosEtiqueta;
}


export function getMensaje(state, dato) {
  if (dato.medida4x6 != undefined) {
    state.selectedMensaje = dato;
  }
}

export function setFiltro(state, buscar) {
  state.filtro = buscar;
}

export function setCamposPersonalizados(state, dato) {
  state.selectedCamposPersonalizados.nombre = '';
}

/**
 * Mutación para limpiar el formulario de campos personalizados de empresas
 *
 * @export
 * @param {*} state
 */
export function resetCamposPersonalizados(state) {
  state.listadoCamposPersonalizados = {lista: []}
}

export function setListadoCamposPersonalizados(state, dato) {
  if (dato !== []) {
    state.listadoCamposPersonalizados = dato;
  }
}

export function setEstadoCamposPersonalizados(state, dato) {
  if (dato !== []) {
    state.listadoCamposPersonalizados = dato;
  }
}

export function setDiligenciados(state, dato) {
  if (dato !== null) {
    state.selectedResumenRpq = dato;
  }
}

export function setAccion(state, accion) {
  state.accion = accion;
}


export function getImagenLogo(state, dato) {
  if (dato.orientacion !== null) {
    state.selectedImagen = dato;
  } else {
    state.selectedImagen = {
      orientacion: 'Horizontal',
      imagen: ''
    };
  }
}

/**
 * Actualizar la imagen de la empresa actual.
 * 
 * @param Object state 
 * @param Object nextState 
 * @returns 
 */
export function setSelectedImagenCurrentCompany(state, nextState) {
  if (nextState.orientacion != null) {
    state.selectedImagenCurrentCompany = nextState;
    return
  } 
  
  state.selectedImagenCurrentCompany = {
    orientacion: 'Horizontal',
    imagen: ''
  };
}

export function setListaEmpresa(state, empresas) {
  state.empresas = empresas;
}

export function setImportesProcesados(state, importesAgendados) {
  state.importesAgendados = importesAgendados;
}

export function setRoles(state, roles) {
  state.roles = roles;
  state.rolesSeleccionados = [];
  roles.forEach(item => {
    state.rolesSeleccionados.push({
      id: item.id,
      rol: item.rol
    });
  });
}

export function setPermisos(state, permisos) {
  state.permisos = permisos;
}

export function cambiaRolUsuario(state, rol) {
  state.rolusuario.id = rol;
}

export function setPermisosRol(state, permisos) {
  state.permisosSeleccionados.ids = permisos.data;
}

export function setRolUsuario(state, rol) {
  state.rolusuario.id = rol.rolusuario;
}

export function filtraPermiso(state, permiso) {
  state.buscaPermiso.permiso = permiso;
}

/**
 * Mutación para asignar o designar permisos.
 *
 * @export
 * @param {*} state
 * @param {*} data contiene el id del permiso y el número de índice del mismo
 */
export function cambiaPermiso(state, data) {
  let permisosSeleccionados = JSON.parse(JSON.stringify(state.permisosSeleccionados));
  if (data.index === -1) {
    permisosSeleccionados.ids.push(data.id_permiso);
  } else {
    permisosSeleccionados.ids.splice(data.index, 1);
  }

  state.permisosSeleccionados.ids = permisosSeleccionados.ids;
}

/**
 * Mutación para limpiar los filtros del administrador de usuarios.
 *
 * @export
 */
export function resetUserFilter(state) {
  let filter = defaultUserFilter();
  filter.empresa = state.users.id_empresa;
  Object.assign(state.users, filter);
}

export function setPage(state, page) {
  state.users.page = page;
}

export function setPerPage(state, perPage) {
  state.users.perPage = perPage;
}

export function setPageEmpresa(state, page) {
  state.filtro.page = page;
}

export function setEmpUs(state, id) {
  state.users.id_empresa = id;
}

export function setPermisosRoles(state) {
}

export function creacion_id(state, id) {
  state.id_creado = id;
}

export function asignaSumaRpq(state, cantidadTotal) {
  state.selectedAsignacionRpq.totalRpq = cantidadTotal;
}

export function restauraValorSumar(state) {
  state.selectedAsignacionRpq.valorSumar = 0;
}

export function resetSelectedUsuario(state) {
  Object.assign(state.selectedUsuario, defaultUsuario());
}

/**
 * Mutación para resetear el formulario de diseño.
 *
 * @export
 * @param {*} state
 */
export function resetDiseno(state) {
  Object.assign(state.selectedDiseno, defaultDiseno());
}

/**
 * Mutación para resetear el formulario de etiquetas.
 *
 * @export
 * @param {*} state
 */
export function resetMensaje(state) {
  Object.assign(state.selectedMensaje, defaultMensaje());
}

export function resetSelectedEmpresa(state) {
  Object.assign(state.selectedEmpresa, defaultEmpresa());
}

/**
 * Mutación para limpiar el buscador de empresas.
 *
 * @export
 * @param {*} state
 */
export function resetEmpresas(state) {
  Object.assign(state.filtro, defaultCompanyFilter());
  state.empresas      = [];
}

export function setconexion(state, data) {
  state.conexion = data;
}

export function cambiaContratista(state, contratista) {
  state.contratista = contratista;
}

export function setContratistas(state, contratistas) {
  state.contratistas = contratistas;
}

export function cambiarEstadoContratista(state, contratista) {
  state.contratistas.data.map(c => {
    if (c.id === contratista.id) {
      c.checked = contratista.checked;
    }
  });
}

/**
 * Establecer el nombre de la generales
 */
export function establecerNombreEmpresa(state, nombre) {
  state.selectedEmpresa.nombre = nombre;
}

/**
 * Mutación para limpiar caracteres no permitidos en el nit
 *
 * @export
 * @param {*} state
 * @param {*} nit
 */
export function setNitCompany(state, nit) {
  state.selectedEmpresa.nit = nit;
}

/**
 * Establecer el nombre del usuario
 */
export function establecerNombreUsuario(state, nombre) {
  state.selectedUsuario.name = nombre;
}


/**
 * Mostrar modal usuario
 */
export function establecerModalUsuario(state, mostrar = true) {
  state.modal_usuario.mostrar = mostrar;
}


/**
 * Establecer accionUsuario
 */
export function establecerAccionUsuario(state, accionUsuario) {
  state.accionUsuario = accionUsuario;
}

/**
 * Establecer selectedUsuario
 */
export function establecerSelectedUsuario(state, selectedUsuario) {
  selectedUsuario.roles_usuario = selectedUsuario.roles.map(o => o['id']);
  state.selectedUsuario = selectedUsuario;
}


/**
 * Mostrar modal_campos_personalizados
 */
export function establecerModalCamposPersonalizados(state, mostrar = true) {
  state.modal_campos_personalizados.mostrar = mostrar;
}

/**
 * Establecer accionCamposPersonalizados
 */
export function establecerAccionCamposPersonalizados(state, accionCamposPersonalizados) {
  state.accionCamposPersonalizados = accionCamposPersonalizados;
}

/**
 * Establecer selectedCamposPersonalizados
 */
export function establecerSelectedCamposPersonalizados(state, selectedCamposPersonalizados) {
  state.selectedCamposPersonalizados = JSON.parse(JSON.stringify(selectedCamposPersonalizados));
}

/**
 * Mutación para limpiar el modal de campos personalizados.
 *
 * @export
 * @param {*} state
 */
export function resetSelectedCamposPersonalizados(state) {
  Object.assign(state.selectedCamposPersonalizados, defaultCamposPersonalizados());
}

/**
 * Mutación para resetear el formulario de contratistas.
 *
 * @export
 * @param {*} state
 */
export function resetParamsContratista(state) {
  Object.assign(state.paramsContratista, defaultParamsContratista());
}

export function establecerLicenciaActiva(state, licencia_activa) {
  state.licencia_activa = licencia_activa;
}

export function establecerLicencia(state, licencia) {
  state.licencia = licencia;
}

/**
 * Mutación que carga el listado de usuarios internos MyS con rol Admin.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} data contiene los usuarios.
 */
export function setListadoUsuarioInternos(state, data) {
    state.listadoUsuarioInternos = data;
}

/**
 * Establecer un valor para la variable providers.
 */
export function setProviders(state, providers)
{
    state.providers = providers;
}

/**
 * Mutación que carga el listado de usuarios internos MyS con rol Admin.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} data contiene los usuarios.
 */
export function setDetalleEmpresa(state, data) {
  state.empresa = data;
}

/**
 * Mutación que estable las configuraciones del reporte de FDS del usuario.
 *
 * @param {*} state: contiene la información del estado.
 * @param {*} dataconfig: payload con la información de configuración del usuario.
 * @author Fernando Claros
 */
export function setFdsConfigsReportUser(state, dataconfig) {
  state.fdsConfigsReportUser = dataconfig;
}

/**
 * Mutación que estable las configuraciones de las ubicaciones del reporte de FDS del usuario.
 *
 * @param {*} state: contiene la información del estado.
 * @param {*} dataconfig: payload con la información de las nuevas Ubicaciones.
 * @author Fernando Claros
 */
export function setLocationsToFdsConfigsReportUser(state, nextLocations) {
  state.fdsConfigsReportUser = { ...state.fdsConfigsReportUser, locations: nextLocations };
}

/**
 * Mutación que estable las configuraciones del reporte de FDS del usuario en sus datos iniciales
 *
 * @param {*} state: contiene la información del estado.
 * @author Fernando Claros
 */
export function setDefaultDataFdsConfigsReportUser(state) {
  state.fdsConfigsReportUser = dataInititalFdsConfigsReport();
}

/**
 * Mutación que estable la configuració de la variable configurable de empresa por usuario.
 *
 * @param {*} state: contiene la información del estado.
 * @param {*} nextState: payload con la información de las nuevas Ubicaciones.
 * @author Fernando Claros
 */
export function setConfigVarUser(state, nextState) {
  state.configVarUser = nextState;
}

/**
 * Mutación que estable las nuevas variables configurable de empresa.
 *
 * @param {*} state: contiene la información del estado.
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setConfigVarCompany(state, nextState) {
  state.configVarCompany = nextState;
}

/**
 * Estable información sobre el resumen de los productos de una empresa.
 *
 * @param {*} state
 * @param {*} summaryInfo
 */
export function setSummary(state, summaryInfo) {
  state.summaryInfo = summaryInfo;
}

/**
 * Mutación que establece si un usuario autenticado puede acceder al tabs de permisos.
 *
 * @param {*} state: contiene la información del estado.
 * @param {boolean} assingPermissions - contiene el nuevo estado para asignar permisos
 * @author Fernando Claros
 */
export function setAssingPermissions(state, assingPermissions) {
    state.assingPermissions = assingPermissions;
}

/**
 * Mutación que establece si la empresa seleccionada es valida.
 *
 * @param {*} state: contiene la información del estado.
 * @param {int} urlCompanyId - contiene el id de la empresa en la url.
 */
export function validateCompanyUrl(state, urlCompanyId) {
  state.validateCompany = state.selectedEmpresa.id == urlCompanyId;
}
